export default "__VITE_ASSET__BvN7qRf2__"